import { BehaviorSubject, combineLatest } from "rxjs";
import { ApiConnectService } from "../../Services/ApiConnectService";
import { TournamentDataService } from "../../Services/TournamentDataService";
import { navbarData } from "../../components/navbar/Navbar.ViewModel";
import { eventData } from '../../Models/Outbound/EventData';
import { eventState } from "../../Models/Common/EventState";
import { CommonFormatsService as formats } from "../../Services/CommonFormatsService";
import { loadingState } from "../../Models/Common/LoadingState";
import { eventDetails } from "../../Models/Common/EventDetails";

export class eventsDashboardViewModel {
    navbarDataSubject: BehaviorSubject<navbarData>;
    loadingStateSubject = new BehaviorSubject<loadingState>(loadingState.loading);
    eventsSubject = new BehaviorSubject<eventViewModel[]>([]);

    acs = new ApiConnectService();
    tournamentService = new TournamentDataService(this.acs);

    constructor(navbarDataSubject: BehaviorSubject<navbarData>) {
        this.navbarDataSubject = navbarDataSubject;
        this.refreshData();
    }

    refreshData = () => {
            this.tournamentService.GetAllEvents().subscribe(apiEvents => {
            if (apiEvents.result) {
                this.loadingStateSubject.next(loadingState.loaded);
                var events = apiEvents.result.events.map(event => eventViewModel.fromApiEvent(event));
                this.eventsSubject.next([]);
                this.eventsSubject.next(events ?? []);
                console.log("Events Dashboard updated with " + events?.length + " events");
                setTimeout(() => {
                    this.loadingStateSubject.next(loadingState.success);
                }, 500);
                setTimeout(() => {
                    this.loadingStateSubject.next(loadingState.hidden);
                }, 1800);
            } else {
                this.loadingStateSubject.next(loadingState.error);
            }
        });
    }

    updateEventState = (eventId: string, newState: eventState) => {
        this.tournamentService.PutEventState(eventId, newState).subscribe(apiEvent => {
            if (apiEvent) {
                this.refreshData();
            }
        });
    }
}

export class eventViewModel {
    eventId: string;
    state: eventState;
    details: eventDetails;
    highestPairingsRound: number;
    highestStandingsRound: number;
    pairingsLastUpdated: string;
    pairingsReadableLastUpdated: string;
    pairingsUpdateCount: number;
    standingsLastUpdated: string;
    standingsReadableLastUpdated: string;
    standingsUpdateCount: number;
    streamDataLastUpdated: string;
    streamDataReadableLastUpdated: string;
    streamDataUpdateCount: number;

    deepCopy = (): eventViewModel => {
        var copy = new eventViewModel();
        copy.eventId = this.eventId;
        copy.state = this.state;
        copy.details = this.details;
        copy.highestPairingsRound = this.highestPairingsRound;
        copy.highestStandingsRound = this.highestStandingsRound;
        copy.pairingsLastUpdated = this.pairingsLastUpdated;
        copy.pairingsReadableLastUpdated = this.pairingsReadableLastUpdated;
        copy.pairingsUpdateCount = this.pairingsUpdateCount;
        copy.standingsLastUpdated = this.standingsLastUpdated;
        copy.standingsReadableLastUpdated = this.standingsReadableLastUpdated;
        copy.standingsUpdateCount = this.standingsUpdateCount;
        copy.streamDataLastUpdated = this.streamDataLastUpdated;
        copy.streamDataReadableLastUpdated = this.streamDataReadableLastUpdated;
        copy.streamDataUpdateCount = this.streamDataUpdateCount;
        return copy;
    }
}

export namespace eventViewModel {
    export function fromApiEvent(apiEvent: eventData): eventViewModel {
        var newEvent = new eventViewModel();
        newEvent.eventId = apiEvent.eventId;
        newEvent.state = apiEvent.state;
        newEvent.details = apiEvent.details;
        newEvent.highestPairingsRound = apiEvent.highestPairingsRound;
        newEvent.highestStandingsRound = apiEvent.highestStandingsRound;
        newEvent.pairingsLastUpdated = apiEvent.pairingsLastUpdated;
        newEvent.pairingsReadableLastUpdated = formats.formatOptionalDate(apiEvent.pairingsLastUpdated);
        newEvent.pairingsUpdateCount = apiEvent.pairingsUpdateCount;
        newEvent.standingsLastUpdated = apiEvent.standingsLastUpdated;
        newEvent.standingsReadableLastUpdated = formats.formatOptionalDate(apiEvent.standingsLastUpdated);
        newEvent.standingsUpdateCount = apiEvent.standingsUpdateCount;
        newEvent.streamDataLastUpdated = apiEvent.streamDataLastUpdated;
        newEvent.streamDataReadableLastUpdated = formats.formatOptionalDate(apiEvent.streamDataLastUpdated);
        newEvent.streamDataUpdateCount = apiEvent.streamDataUpdateCount;
        return newEvent;
    }
}